<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <v-container>
          <v-layout row wrap align-center>
            <v-flex xs12 sm6 class="pb-2 pt-4">
              <h1>Terms &amp; Conditions</h1>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <CountdownTimer />
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-card flat>
          <v-card-text>
            <div class="loading" v-if="loading === true">
              <pulse-loader :loading="loading"></pulse-loader>
            </div>
            <div v-else>
              <div v-html="departing_conditions" />
              <v-container>
                <v-layout row justify-center align-center>
                  <v-spacer></v-spacer>
                  <v-flex shrink v-if="complete !== true">
                    <v-checkbox
                      label="I agree to these terms"
                      v-model="form_fields.agree_to_terms"
                      @change="validateTerms()"
                    ></v-checkbox>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-container>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared";
import CountdownTimer from "@/components/CountdownTimer.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "TermsConditions",
  mixins: [Shared],
  components: {CountdownTimer, PulseLoader},
  mounted() {
    this.validateTerms();
    // if (this.line_items === null) {
      this.getSummary();
    // }
  },
  computed: {
    departing_conditions() {
      if (this.line_items !== null) {
        return this.line_items.terms;
      } else {
        return "";
      }
    }
  }
};
</script>
